$(document).ready(function() {
  /* GLOBAL VARIABLE */
  if (Cookies != undefined) {
    var Cookies2 = Cookies.noConflict(); 
  }
  //fix conflict Cookie
  /* ADD CLASS FOR PARENT OF LAZYLLOAD IMAGES */


  /* CHALLENGE PAGE SCROLL TO TOP */
  $(window).on('load', function(){
    if ($('.shopify-challenge__container .shopify-challenge__message').length) {
      $("html, body").animate({ scrollTop: 0 }, "fast");
    }
  });

  /* TOGGLE FILTER TITLE ON SIDEBAR FILTER */
  $(document).on('click', 'h5.has-toggle', function() {
      $(this).toggleClass('active');
      $(this).next().slideToggle();
  });
  /* HANDLE ERROR FUNCTION */
  function handleError(XMLHttpRequest) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    var errorMessage = '';
    if (!!data.message) {
      errorMessage = data.description
    } else {
      errorMessage = 'Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.';
    }
    if (errorMessage != '') {
      //alert(errorMessage);
      $('#gp-popup-addtocart-error .popup__column').html(errorMessage);
      $.magnificPopup.open({
        items: {
          src: '#gp-popup-addtocart-error' 
        },
        type: 'inline',
        mainClass: 'modal_addtocart_popup mfp-fade',
        removalDelay: 300
      });
    }
  }

  /* Custom header newsletter */
  $(document).on('click', '.newsletter-link .newsletter-action', function(e) {
    e.preventDefault();
    $.magnificPopup.open({
      items: {
        src: '#newsletter-popup' 
      },
      type: 'inline',
      removalDelay: 300,
      mainClass: 'modal_newsletter_popup mfp-fade no_checkbox'
    });
  });
  /* Custom Sticky menu */
  if ($('#header.sticky-header').length) {
    var headerHeight = $('.sticky-header .site-header').height();
    $('.sticky-header #pd-sticky').height(headerHeight);
    $(window).resize(function() {
      setTimeout(function() {
        var headerHeight = $('.sticky-header .site-header').height();
        $('.sticky-header #pd-sticky').height(headerHeight);
      }, 200);
    });
  }
  if ($('#header.sticky-header-mobile').length) {
    var headerHeightMobile = $('.sticky-header-mobile .site-header').height();
    $('.sticky-header-mobile #pd-sticky-mobile').height(headerHeightMobile);
    $(window).resize(function() {
      setTimeout(function() {
        var headerHeightMobile = $('.sticky-header-mobile .site-header').height();
        $('.sticky-header-mobile #pd-sticky-mobile').height(headerHeightMobile);
      }, 200);
    });
  }

    /* Custom menu */
  setTimeout(function () {
    var megamenusub = $(".site-header .nav-megamenu .dropdown");
    var height = $(window).height();
    var wdw = $(window).width();

    if (wdw > 1024) {
      for (var i = 0; i < megamenusub.length; i++) {
          var megamenu_sub = $('.' + megamenusub[i].getAttribute('class').replace(/\s+/g, '.') + ' .dropdown-menu');
          var getClassMegamenu = megamenusub[i].getAttribute('class');
          if (getClassMegamenu.includes("fullwidthfluid") === true) {
              megamenu_sub.offset({left: 0});
              megamenu_sub.css('width', wdw);
          }
      }
    }
  }, 100);
  $(window).resize(function() {
    setTimeout(function () {
      var megamenusub = $(".site-header .nav-megamenu .dropdown");
      var height = $(window).height();
      var wdw = $(window).width();

      if (wdw > 1024) {
        for (var i = 0; i < megamenusub.length; i++) {
            var megamenu_sub = $('.' + megamenusub[i].getAttribute('class').replace(/\s+/g, '.') + ' .dropdown-menu');
            var getClassMegamenu = megamenusub[i].getAttribute('class');
            if (getClassMegamenu.includes("fullwidthfluid") === true) {
                megamenu_sub.offset({left: 0});
                megamenu_sub.css('width', wdw);
            }
        }
      }
    }, 100);
    var height = $(window).height();
    var heightMenu = $('.site-header').height();
    $('.mobile-navigation').css({
        "height": height - heightMenu + 'px',
        "top": heightMenu
    });
  });
  var heightMenu = $('.site-header').height();
  var height = $(window).height();
  $('.mobile-navigation').css({
      "height": height - heightMenu + 'px',
      "top": heightMenu
  });
  /* Custom Sticky header only when scroll down not scroll up */
  if ($('#header.sticky-header').length || $('#header.sticky-header-mobile').length) {
    var lastScrollTop = 0;
    var navbarHeight = $('#header').outerHeight();
    // on scroll, let the interval function know the user has scrolled
    $(window).scroll(function(event){
      if (!$('.header-cart').hasClass('active') && !$('html').hasClass('nav-open') && !$('html').hasClass('nav-open-additional-menu')) {
        var st = $(this).scrollTop();

        // If they scrolled down and are past the navbar, add class .nav-up.
        // This is necessary so you never see what is "behind" the navbar.
        if (st > lastScrollTop && st > navbarHeight){
            // Scroll Down
            $('#header').removeClass('nav-down').addClass('nav-up');
            var headerHeightMobile = $('.sticky-header-mobile .site-header').height();
            $('.nav-up .site-header .header-cart .cart-slideout,.nav-up .site-header .header-cart.toggle-cart-slide:after').css('top',headerHeightMobile+'px');
        } else {
            // Scroll Up
            if (st > navbarHeight) {
              if(st + $(window).height() < $(document).height()) {
                $('#header').removeClass('nav-up').addClass('nav-down');
                  $('.site-header .header-cart .cart-slideout,.site-header .header-cart.toggle-cart-slide:after').css('top',0+'px');
              }
            }
            if (st == 0) {
              $('#header').removeClass('nav-up').removeClass('nav-down');
                $('.site-header .header-cart .cart-slideout,.site-header .header-cart.toggle-cart-slide:after').css('top',0+'px');
            }
        }
        
        lastScrollTop = st;
      }
    });
  }

  /* SLIDEOUT MENU */
  $(document).on('click', '#header .toggle_menu_mobile', function() {
    $('html').toggleClass('nav-open');
  });

  $(document).on('click', '#header .toggle_menu_desktop', function() {
    $('html').toggleClass('nav-open');
  });

  $(document).on('touchend', '#toolbar-mobile .toggle_menu_mobile', function() {
    $('html').toggleClass('nav-open');
  });

  $(document).on('click touchend', '.slideout-menu #mobile_navigation_menu .site-nav .toggle-menu', function(e) {
    e.preventDefault();
    $(this).toggleClass('active');
    $(this).next().slideToggle();
  });

  $(document).on('click', '.slideout-menu .slm-tab-title li a', function(e) {
    e.preventDefault();
    if (!$(this).hasClass('active')) {
      $('.slideout-menu .slm-tab-title li a').removeClass('active');
      $(this).addClass('active');
      var id = $(this).attr('href');
      $('.slideout-menu .slm-tab-content .tab-content').removeClass('active');
      $(id).addClass('active');
    }
  });

  $(document).on('click', '.gp-popup-account .slm-tab-title li a', function(e) {
    e.preventDefault();
    if (!$(this).hasClass('active')) {
      $('.gp-popup-account .slm-tab-title li a').removeClass('active');
      $(this).addClass('active');
      var id = $(this).attr('href');
      $('.gp-popup-account .slm-tab-content .tab-content').removeClass('active');
      $(id).addClass('active');
    }
  });

  /* HEADER ADDITIONAL MENU ON DESKTOP */
  $(document).on('click', '.toggle-desktop-additional-menu', function() {
    $('html').toggleClass('nav-open-additional-menu');
  });
  if ($('div').hasClass('header-settings-desktop')) {
      $('html').toggleClass('open-additional-menu-desktop');
  }
  //Height 404
  var height = $(window).height();
  $('.gp-404-template').css({
      'min-height': height + 'px'
  });
  $('.gp-404-content-wrapper').css({
      'min-height': height + 'px'
  });
  $(window).resize(function() {
    var height = $(window).height();
    $('.gp-404-template').css({
        'min-height': height + 'px'
    });
    $('.gp-404-content-wrapper').css({
        'min-height': height + 'px'
    });
  });
  /* MINICART FUNCTIONS */
  //reinit minicart
  function refreshMiniCart(lineitem, quantity) {
    if ($('body').hasClass('template-cart')) {
      window.location.reload();
    } else {
      $.ajax({
        method: "GET",
        url: "/cart",
        data: {"view": "ajax"},
        xhrFields: {
          withCredentials: true
        },
        dataType: 'html',
        success: function(response) {
          var headerCartHtml = $(response).find('.header-cart .action-cart').first().html();
          var toolbarCartHtml = $(response).find('.header-cart-item .action-cart').html();
          var contentCartHtml = $(response).find('.header-cart .minicart-content').first().html();
          var subtotal = $(response).find('.header-cart .minicart-content .subtotal .subtotal-price').first().html();
          if($(response).find('.header-cart.empty').length) {
            $('.header-cart').addClass('empty');
          } else {
            $('.header-cart').removeClass('empty');
          }
          if (headerCartHtml) {
            $('.header-cart .action-cart').html(headerCartHtml);
          }
          if (toolbarCartHtml) {
            $('.header-cart-item .action-cart').html(toolbarCartHtml);
          }
          if (contentCartHtml) {
            $('.header-cart .minicart-content').html(contentCartHtml);
          }
          if (lineitem) {
            if (quantity) {
              showSuccessAddToCartPopup(lineitem, quantity, subtotal);
            } else {
              showSuccessAddToCartPopup(lineitem, 1, subtotal);
            }
          }
          //reinit currency
          Currency.convertAll(theme.currency, Currency.currentCurrency);
        }
      });
    }
  }
  // show hide update-quantity button
  $(document).ready(function() {

    $(document).on('keyup change', '.minicart-content .details-qty input', function() {
      var currentQty = $(this).val();
      if (currentQty && currentQty != $(this).data('item-qty')) {
        $(this).next().show();
      } else {
        $(this).next().hide();
      }
    });
    // ajax update quantity in minicart
    //click - +
    $(document).on('click', '.minicart-content .edit-qty', function() {
      var id = $(this).data('cart-item');
      var quantity = $('.minicart-content .details-qty input[data-cart-item="'+ id +'"]').val();
      var oldQuantity = $('.minicart-content .details-qty input[data-cart-item="'+ id +'"]').data('item-qty');

      if (quantity && id) {
        if (quantity == 1 && oldQuantity == 1) {
          $('.header-cart .minicart-content .ajax-loader').show();
          $.ajax({
            method: "POST",
            url: "/cart/update.js",
            data: "updates["+ id +"]=0",
            dataType: "json",
            success: function(response) {
              refreshMiniCart();
            },
            error: function(XMLHttpRequest, textStatus) {
              $('.header-cart .minicart-content .ajax-loader').hide();
              handleError(XMLHttpRequest);
            }
          });
        } else {
          $('.header-cart .minicart-content .ajax-loader').show();
          $.ajax({
            method: "POST",
            url: "/cart/update.js",
            data: "updates["+ id +"]=" + quantity,
            dataType: "json",
            success: function(response) {
              refreshMiniCart();
            },
            error: function(XMLHttpRequest, textStatus) {
              $('.header-cart .minicart-content .ajax-loader').hide();
              handleError(XMLHttpRequest);
            }
          });
        }
      }
    });
    //change value number
    $(document).on('change', '.item-qty.update-cart-item', function() {
      var id = $(this).data('cart-item');
      var quantity = $('.minicart-content .details-qty input[data-cart-item="'+ id +'"]').val();
      var oldQuantity = $('.minicart-content .details-qty input[data-cart-item="'+ id +'"]').data('item-qty');
      
      if (quantity && id) {
        $('.header-cart .minicart-content .ajax-loader').show();
        $.ajax({
          method: "POST",
          url: "/cart/update.js",
          data: "updates["+ id +"]=" + quantity,
          dataType: "json",
          success: function(response) {
            refreshMiniCart();
          },
          error: function(XMLHttpRequest, textStatus) {
            $('.header-cart .minicart-content .ajax-loader').hide();
            handleError(XMLHttpRequest);
          }
        });
      }
    });
    // ajax delete item in minicart
    $(document).on('click', '.minicart-content .action.delete', function() {
      var id = $(this).data('cart-item');
      if (id) {
        $('.header-cart .minicart-content .ajax-loader').show();
        $.ajax({
          method: "POST",
          url: "/cart/update.js",
          data: "updates["+ id +"]=0",
          dataType: "json",
          success: function(response) {
            refreshMiniCart();
          },
          error: function(XMLHttpRequest, textStatus) {
            $('.header-cart .minicart-content .ajax-loader').hide();
            handleError(XMLHttpRequest);
          }
        });
      }
    });
    
      // toggle slideout cart
      $(document).on('click', '.header-cart.toggle-cart-slide .action-cart', function(e) {
        e.preventDefault();
        $('.header-cart.toggle-cart-slide').toggleClass('active');
      });
      $(document).on('click', '.header-cart-item.toggle-cart-slide .action-cart', function(e) {
        e.preventDefault();
        $('.header-cart.toggle-cart-slide').toggleClass('active');
      });
      // click outsite close cart slideout
      $(document).on('click', function(e) {
          var container = $('.header-cart.toggle-cart-slide .minicart-content');
          var container2 = $('.header-cart.toggle-cart-slide .action-cart');
          var container3 = $('.header-cart-item.toggle-cart-slide .action-cart');
          if (!container.is(e.target) && container.has(e.target).length === 0 && !container2.is(e.target) && container2.has(e.target).length === 0 && !container3.is(e.target) && container3.has(e.target).length === 0) {
            $('.header-cart.toggle-cart-slide').removeClass('active');
          }
      });
    

    // close minicart
    $(document).on('click', '.header-cart .btn-minicart-close', function() {
      $('.header-cart.toggle-cart-slide').removeClass('active');
    });

    // CHANGE MAX HEIGHT OF MINICART SLIDE OUT
    function calcMaxHeightCartContent() {
      var windowHeight = $(window).height();
      var headerHeight = $('.site-header').height();
      
      // 201 is total height of minicart title and minicart bottom part
      var maxHeightSlideoutContent = windowHeight - 211;
      // check if max height > 20 enough to touch and < 318 that styled in css file
      if (maxHeightSlideoutContent > 20) {
        $('.header-cart .minicart-content.cart-slideout .minicart-items-wrapper').css('max-height', maxHeightSlideoutContent);
      } else {
        $('.header-cart .minicart-content.cart-slideout .minicart-items-wrapper').css('max-height', '');
      }
    }
    // init on first load
    calcMaxHeightCartContent();
    $(window).on('resize', function() {
      // reinit on resize
      setTimeout(function() {
        calcMaxHeightCartContent();
      }, 300);
    });
  });

  /* AJAX PRODUCT ITEM */
  function showSuccessAddToCartPopup(lineitem, quantity, subtotal) {
    if (lineitem) {
      var pName = lineitem.title;
      var pImage = lineitem.image;
      $('#gp-popup-addtocart .product-confirm-name').text(pName);
      $('#gp-popup-addtocart .popup__image-wrapper').html('<img src="'+ pImage +'" />');
      $('#gp-popup-addtocart .product-confirm-subtotal .price').html(subtotal);
      $('#gp-popup-addtocart .product-confirm-qty .value').text(quantity);
      var itemText = $('#gp-popup-addtocart .ajax_header .one-item-text').text();
      if (quantity > 1) {
        itemText = $('#gp-popup-addtocart .ajax_header .other-item-text').text();
      }
      $('#gp-popup-addtocart .ajax_header .item-added-to-cart').text(quantity + ' ' + itemText);
      
      $.magnificPopup.open({
        items: {
          src: '#gp-popup-addtocart' 
        },
        type: 'inline',
        mainClass: 'modal_addtocart_popup mfp-fade',
        removalDelay: 300
      });
    }
  }
  $(document).on('click', '#gp-popup-addtocart .btn-close', function(e) {
    e.preventDefault();
    $('#gp-popup-addtocart .mfp-close').trigger('click');
  });
  $(document).on('click', '.btn-add-to-cart', function(e) {
    e.preventDefault();
    var btn = $(this);
    var vId = btn.data('vid');
    btn.addClass('ajax-loader-btn');
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: 'quantity=1&id=' + vId,
      dataType: 'json',
      xhrFields: {
        withCredentials: true
      },
      success: function(lineitem) {
        btn.removeClass('ajax-loader-btn');
        refreshMiniCart(lineitem, 1);
      },
      error: function(XMLHttpRequest, textStatus) {
        btn.removeClass('ajax-loader-btn');
        handleError(XMLHttpRequest);
      }
    });
  });

  // add to cart in product page and quickview
  $('form.product-form .single-option-selector').on('click', function() {
    $(this).prev().find('.selected-value').html($(this).find(":selected").val());
  })
  
  $(document).on('click', '.btn-add-to-cart-product-page', function(e) {
    e.preventDefault();
    var btn = $(this);
    var form = btn.closest('form');
    var vId = form.find('select.product-form__variants').first().val();
    var qty = form.find('.gp-product-qty input.qty-input').first().val();
    var $properties = form.find('[name^="properties"]');
    var properties = {};
    $($properties).each(function(index, el){
      var name = $(el).attr('name').substr(11, $(el).attr('name').length - 12)
      properties[name] = $(el).val();
      
    });
    
    var data = {
      quantity: qty,
      id: vId,
      properties: properties
    }

    if (vId && qty > 0) {
      btn.addClass('ajax-loader-btn');
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        xhrFields: {
          withCredentials: true
        },
        success: function(lineitem) {
          btn.removeClass('ajax-loader-btn');
          refreshMiniCart(lineitem, qty);
        },
        error: function(XMLHttpRequest, textStatus) {
          btn.removeClass('ajax-loader-btn');
          handleError(XMLHttpRequest);
        }
      });
    }
  });

  /* QUICK VIEW */
  $(document).on('change', 'form.product-form-quickview select.single-option-selector-quickview', function() {
    var val = '';
    $('form.product-form-quickview select.single-option-selector-quickview').each(function() {
      if (val == '') {
        val += $(this).val();
      } else {
        val += ' / ' + $(this).val();
      }
    });
    if (val != '') {
      $('form.product-form-quickview select#ProductSelect-quickview option').each(function() {
        if (val == $(this).text().trim()) {
          var optionValue = $(this).val();
          $('form.product-form-quickview select#ProductSelect-quickview').val(optionValue).change();
          // price
          var vPrice = parseInt($(this).data('price'));
          var vComparePrice = parseInt($(this).data('compare-at-price'));
          var priceHtml = '';
          if (vComparePrice > vPrice) {
            priceHtml = `<div class="price price--on-sale" data-price="">
              <div class="price__regular">
                
                  <span class="visually-hidden visually-hidden--inline">Regular price</span>
                
              
            <span class="price-item price-item--regular" data-regular-price="">
            <span class="money">`+ Shopify.formatMoney(vComparePrice) +`</span>
            </span>
            
            </div>
            <div class="price__sale">
            
            <span class="visually-hidden visually-hidden--inline">Sale price</span><span class="price-item price-item--sale" data-sale-price=""><span class="money">
            `+ Shopify.formatMoney(vPrice) +`</span></span><span class="price-item__label" aria-hidden="true">Sale</span></div></div>`;
          } else {
            priceHtml = '<div class="price" data-price=""><div class="price__regular"><span class="visually-hidden visually-hidden--inline">Regular price</span><span class="price-item price-item--regular" data-regular-price=""><span class="money">'+ Shopify.formatMoney(vPrice) +'</span></span></div><div class="price__sale"><span class="visually-hidden visually-hidden--inline">Sale price</span><span class="price-item price-item--sale" data-sale-price=""><span class="money">'+ Shopify.formatMoney(vPrice) +'</span></span><span class="price-item__label" aria-hidden="true">Sale</span></div></div>';
          }
          if (priceHtml != '') {
            $('#gp-popup-quickview .product-info-price').html(priceHtml);
          }
          // available
          var addToCartBtn = $('.product-form-quickview .btn-add-to-cart-product-page');
          var soldOutBtnText = addToCartBtn.data('text-soldout');
          var addToCartBtnText = addToCartBtn.data('text-add-to-cart');
          if ($(this).prop('disabled')) {
            addToCartBtn.prop('disabled', true);
            if (soldOutBtnText && soldOutBtnText != '') {
              addToCartBtn.find('span').text(soldOutBtnText);
            }
          } else {
            addToCartBtn.prop('disabled', false);
            if (addToCartBtnText && addToCartBtnText != '') {
              addToCartBtn.find('span').text(addToCartBtnText);
            }
          }
        }
      });
    }
  });

  function initQuickviewJs() {
    $('#gp-popup-quickview .quickview-popup-content .owl-carousel').owlCarousel({
      items: 1,
      nav: true,
      dots: false,
      loop: false,
      rewind: true,
      lazyLoad: true,
      mouseDrag: false,
      navText : ['<i class="theme-iconback"></i>','<i class="theme-iconnext"></i>']
    });
    $('#gp-popup-quickview').addClass('loaded');
  }
  $(document).on('click', '.js-open-quickview', function(e) {
      e.preventDefault();
      var href = $(this).attr('href');
      $('#gp-popup-quickview .quickview-popup-content').html('');
      $('#gp-popup-quickview').removeClass('loaded');
      $.magnificPopup.open({
        items: {
          src: '#gp-popup-quickview' 
        },
        type: 'inline',
        mainClass: 'modal_quickview_popup mfp-fade',
        removalDelay: 300
      });
      $.ajax({
        method: "GET",
        url: href,
        data: {"view": "quickview"},
        xhrFields: {
          withCredentials: true
        },
        dataType: 'html',
        success: function(response) {
          var pHtml = $(response).find('.product-quickview-container').first().html();
          $('#gp-popup-quickview .quickview-popup-content').html(pHtml);
          //reinit currency
          Currency.convertAll(theme.currency, Currency.currentCurrency);
          initQuickviewJs();
        }
      });
  });

  /* VARIABLE FOR COMPARE AND WISHLIST */
  var soldOutText = 'Sold out';
  if (soldOutText == '') {
    soldOutText = 'Sold out';
  }
  var selectOptionText = 'Select options';
  if (selectOptionText == '') {
    selectOptionText = 'Select options';
  }
  var addToCartText = 'Add to cart';
  if (addToCartText == '') {
    addToCartText = 'Add to cart';
  }
  var removeCompareProduct = 'Remove';
  /* COMPARE PRODUCT */
  function showHideCompare(isShow) {
    if ($('.compare-wrapper').length) {
      if (isShow) {
        $('.compare-wrapper').show();
        $('.compare-wrapper-empty').hide();
      } else {
        $('.compare-wrapper').hide();
        $('.compare-wrapper-empty').show();
      }
    }
  }
  function addProductHtmlToPopup(product) {
    var pImage = '<td data-compare-handle="'+product.handle+'"><a href="#" class="btn-remove-compare" data-product-handle="'+product.handle+'" title="'+ removeCompareProduct +'"><span>'+ removeCompareProduct +'</span></a><div class="image"><a href="'+ product.url +'" class="hover-change-img">';
    if (product.featured_image) {
      pImage += '<img src="'+ product.featured_image +'" alt="'+ product.title +'" width="200" height="200"/>';
    }
    if (product.images.size > 1) {
      pImage += '<img src="'+ product.images[1] +'" alt="'+ product.title +'"/>';
    }
    pImage += '</a></div></td>';
    var pPrice = '<td data-compare-handle="'+product.handle+'">';
    if (product.compare_at_price > product.price) {
      pPrice += '<div class="price price--on-sale" data-price="">';
    } else {
      pPrice += '<div class="price" data-price="">';
    }
    if (product.compare_at_price > product.price) {
      pPrice += '<div class="price__regular"><span class="price-item price-item--regular" data-regular-price><span class="money">'+ Shopify.formatMoney(product.compare_at_price) +'</span></span></div>';
    } else {
      pPrice += '<div class="price__regular"><span class="price-item price-item--regular" data-regular-price><span class="money">'+ Shopify.formatMoney(product.price) +'</span></span></div>';
    }
    pPrice += '<div class="price__sale"><span class="price-item price-item--sale" data-sale-price><span class="money">'+ Shopify.formatMoney(product.price) +'</span></span></div>';
    pPrice += '</div></td>';
    var pTitle = '<td data-compare-handle="'+product.handle+'">' + '<a href="'+product.url+'">' + product.title + '</a>' + '</td>';
    var pCart = '';
    if (product.available) {
      var variants = product.variants;
      if (variants.length > 1) {
        pCart = '<td data-compare-handle="'+product.handle+'"><a href="'+ product.url +'" class="btn--link active btn-select-option js-open-quickview" data-title="'+ selectOptionText +'"><span>'+ selectOptionText +'</span></a></td>';
      } else {
        pCart = '<td data-compare-handle="'+product.handle+'"><a href="'+ product.url +'" class="btn--link active btn-add-to-cart" data-vid="'+ variants[0].id +'" data-title="'+ addToCartText +'"><span>'+ addToCartText +'</span></a></td>';
      }
    } else {
      pCart = '<td data-compare-handle="'+product.handle+'"><a href="'+ product.url +'" class="btn--link active btn-soldout" data-title="'+ soldOutText +'"><span>'+ soldOutText +'</span></a></td>';
    }
    var pType = '<td data-compare-handle="'+product.handle+'"><span>-</span></td>';
    if (product.type) {
      pType = '<td data-compare-handle="'+product.handle+'"><span>' + product.type + '</span></td>';
    }
    var pVendor = '<td data-compare-handle="'+product.handle+'"><span>-</span></td>';
    if (product.vendor) {
      pVendor = '<td data-compare-handle="'+product.handle+'"><span>' + product.vendor + '</span></td>';
    }

    $('tr.compare-image').append(pImage);
    $('tr.compare-title').append(pTitle);
    $('tr.compare-price').append(pPrice);
    $('tr.compare-cart').append(pCart);
    $('tr.compare-type').append(pType);
    $('tr.compare-vendor').append(pVendor);
  }

  function addComparedProductToProductPage(product) {
    var cImage = '<a href="'+ product.url +'"><img src="//concretestudio.club/cdn/shop/t/2/assets/blank.png?v=145847663774547154571787713612" data-src="'+ product.featured_image +'" class="lazyload"/></a>';
    var cTitle = '<div class="title"><a title="' + product.title + '" href="'+ product.url +'">'+ product.title +'</a></div>'
    var cPrice = '<div class="price-wrapper" data-product-price="'+ product.id +'"><td data-compare-handle="'+product.handle+'">';
    if (product.compare_at_price > product.price) {
      cPrice += '<div class="price price--on-sale" data-price="">';
    } else {
      cPrice += '<div class="price" data-price="">';
    }
    if (product.compare_at_price > product.price) {
      cPrice += '<div class="price__regular"><span class="price-item price-item--regular" data-regular-price><span class="money">'+ Shopify.formatMoney(product.compare_at_price) +'</span></span></div>';
    } else {
      cPrice += '<div class="price__regular"><span class="price-item price-item--regular" data-regular-price><span class="money">'+ Shopify.formatMoney(product.price) +'</span></span></div>';
    }
    cPrice += '<div class="price__sale"><span class="price-item price-item--sale" data-sale-price><span class="money">'+ Shopify.formatMoney(product.price) +'</span></span></div>';
    cPrice += '</div></td></div>';
    var cButton = '<div class="product-action">';
    if (product.available) {
      var variants = product.variants;
      if (variants.length > 1) {
        cButton += '<a href="'+ product.url +'" class="btn btn-select-option js-open-quickview" data-title="'+ selectOptionText +'"><span class="theme-iconsearch-1"></span></a>';
      } else {
        cButton += '<a href="'+ product.url +'" class="btn btn-add-to-cart" data-vid="'+ variants[0].id +'" data-title="'+ addToCartText +'"><span class="theme-iconshopping-cart1"></span></a>';
      }
    }
    cButton += '</div>'

    var compareItem = '<div class="product-card-item product-card-sidebar" data-compare-handle="'+ product.handle +'"><div class="product-card-list-inner"><div class="image">'+ cImage + cButton +'</div><div class="product-item-details"><div class="bottom-wrapper">'+ cTitle +'<div class="bottom-details"><div class="bottom-middle">'+ cPrice +'</div></div></div></div></div></div>'
    $('.gp-product-sidebar-widget .gp-cf-compared .gp-compared-slider').slick('slickAdd',compareItem);
  }

  function showComparePopup() {
    $.magnificPopup.open({
      items: {
        src: '#gp-popup-compare' 
      },
      type: 'inline',
      mainClass: 'modal_compare_popup mfp-fade',
      removalDelay: 300,
    });
  }
  var compareProducts = [];
  if (typeof(Storage) !== "undefined") {
    if (localStorage.getItem("compareList")) {
      if (Cookies2.get("compare-expire") === undefined) {
        localStorage.removeItem("compareList");
      } else {
        compareProducts = $.parseJSON(localStorage.getItem("compareList"));
      }
    }
    function showCompareInProductPages() {
      if (compareProducts.length) {
        $('.gp-cf-compared .compare-wrapper').show();
        $('.gp-product-sidebar-widget .gp-cf-compared .gp-compared-slider .product-card-sidebar').remove();
        for (var i = 0; i < compareProducts.length; i++) {
          $.getJSON('/products/'+ compareProducts[i] +'.js', function(product) {
            addComparedProductToProductPage(product);
            //reinit currency
            Currency.convertAll(theme.currency, Currency.currentCurrency);
          });
        }
      } else {
        $('.gp-cf-compared .compare-wrapper-empty').show();
        $('.gp-cf-compared .compare-wrapper').hide();
      }
    }
    showCompareInProductPages();

    $(document).on('click', '.btn-remove-compare', function(e) {
      e.preventDefault();
      var handle = $(this).data('product-handle');
      if (compareProducts.length) {
        $('.gp-popup-compare td[data-compare-handle="'+handle+'"]').remove();
        for (var i = 0; i < compareProducts.length; i++) {
          if (handle == compareProducts[i]) {
            compareProducts.splice(i, 1);
            break;
          }
        }
        if(!compareProducts.length) {
          showHideCompare(false);
        }
        localStorage.setItem("compareList", JSON.stringify(compareProducts));
        Cookies2.set("compare-expire", 1, 1);
      }
    });
    $(document).on('click', '.my-account-link .link.compare a', function(e) {
      e.preventDefault();
      showComparePopup();
      if (compareProducts.length) {
        $('.gp-popup-compare .compare-popup-content td').remove();
        for (var i = 0; i < compareProducts.length; i++) {
          $.getJSON('/products/'+ compareProducts[i] +'.js', function(product) {
            addProductHtmlToPopup(product);
            //reinit currency
            Currency.convertAll(theme.currency, Currency.currentCurrency);
          });
        }
        showHideCompare(true);
      } else {
        showHideCompare(false);
      }
    });
    $(document).on('click', '.btn-compared', function(e) {
      e.preventDefault();
      
      var handle = $(this).data('product-handle');
      if (handle && handle != '') {
        var inArray = false;
        for (var i = 0; i < compareProducts.length; i++) {
          if (handle == compareProducts[i]) {
            inArray = true;
            break;
          }
        }
        if(!inArray) {
          compareProducts.unshift(handle);
        }
        showComparePopup();
        if (compareProducts.length) {
          $('.gp-popup-compare .compare-popup-content td').remove();
          for (var i = 0; i < compareProducts.length; i++) {
            $.getJSON('/products/'+ compareProducts[i] +'.js', function(product) {
              addProductHtmlToPopup(product);
              addComparedProductToProductPage(product);
              //reinit currency
              Currency.convertAll(theme.currency, Currency.currentCurrency);
            });
          }
          showHideCompare(true);
        } else {
          showHideCompare(false);
        }
        localStorage.setItem("compareList", JSON.stringify(compareProducts));
        Cookies2.set("compare-expire", 1, 1);
      }
    });
  } else {
    Console.log('No Web Storage support..');
  }

  /* ADD TO WISHLIST */
  $(document).on('click touchend', function (e) {
    var container = $('.wishlist-slideout');
    var container2 = $('.btn-wishlist');
    var container3 = $('.my-account-link .link.wishlist a');
    var container4 = $('.toggle-wishlist-slide');
    if (!container.is(e.target) && container.has(e.target).length === 0 && !container2.is(e.target) && container2.has(e.target).length === 0 && e.target.className != 'btn-remove-wishlist' && !container3.is(e.target) && container3.has(e.target).length === 0 && e.target.className != '.my-account-link .link.wishlist a' && !container4.is(e.target) && container4.has(e.target).length === 0) {
      $('.wishlist-slideout').removeClass('active');
      $('.wishlist-slideout-container').removeClass('active');
    }
  });
  function showHideWishlist(isShow) {
    if (isShow) {
      $('.wishlist-items-wrapper').show();
      $('.wishlist-items-empty').hide();
    } else {
      $('.wishlist-items-wrapper').hide();
      $('.wishlist-items-empty').show();
    }
  }
  function addProductHtmlToWishlist(product) {
    var pRemove = '<a href="#" class="btn-remove-wishlist" data-product-handle="' + product.handle + '"></a>';
    var pImage = '<div class="image"><a href="'+ product.url +'"><img src="'+ product.featured_image +'"/></a></div>';
    var pTitle = '<div class="product-item-name"><a href="'+product.url+'">' + product.title + '</a></div>';
    var pPrice = '<td data-compare-handle="'+product.handle+'">';
    if (product.compare_at_price > product.price) {
      pPrice += '<div class="price price--on-sale" data-price="">';
    } else {
      pPrice += '<div class="price" data-price="">';
    }
    
    if (product.compare_at_price > product.price) {
      pPrice += '<div class="price__regular"><span class="price-item price-item--regular" data-regular-price><span class=money>'+ Shopify.formatMoney(product.compare_at_price, Currency.moneyFormats[Currency.currentCurrency].money_format) +'</span></span></div>';
    } else {
      pPrice += '<div class="price__regular"><span class="price-item price-item--regular" data-regular-price><span class=money>'+ Shopify.formatMoney(product.price, Currency.moneyFormats[Currency.currentCurrency].money_format) +'</span></span></div>';
    }
    pPrice += '<div class="price__sale"><span class="price-item price-item--sale" data-sale-price><span class=money>'+ Shopify.formatMoney(product.price, Currency.moneyFormats[Currency.currentCurrency].money_format) +'</span></span></div>';
    pPrice += '</div></td>';
    var pButton = '';
    if (product.available) {
      var variants = product.variants;
      if (variants.length > 1) {
        pButton = '<a href="'+ product.url +'" class="btn btn-mini btn-select-option js-open-quickview">'+ selectOptionText +'</a>';
      } else {
        pButton = '<a href="'+ product.url +'" class="btn btn-mini btn-add-to-cart" data-vid="'+ variants[0].id +'">'+ addToCartText +'</a>';
      }
    } else {
      pButton = '<a href="'+ product.url +'" class="btn btn-mini btn-soldout">'+ soldOutText +'</a>';
    }

    var itemHtml = '<li class="product-item" data-product-handle="'+ product.handle +'"><div class="product">'+ pImage + '<div class="product-item-details">'+ pRemove+ pTitle + pPrice + '<div class="product-buttons">'+ pButton +'</div></div></div></li>';
    $('.wishlist-items-wrapper .wishlist-items').append(itemHtml);
  }

  function addProductHtmlToWishlistPage(product) {
        var pRemove = '<a href="#" class="btn-remove-wishlist" data-product-handle="' + product.handle + '"></a>';
        var pImage = '<div class="image">'+pRemove+'<a href="'+ product.url +'"><img src="'+ product.featured_image +'"/></a></div>';
        var pTitle = '<div class="product-item-name"><a href="'+product.url+'">' + product.title + '</a></div>';
        var pPrice = '<td data-compare-handle="'+product.handle+'">';
        if (product.compare_at_price > product.price) {
            pPrice += '<div class="price price--on-sale" data-price="">';
        } else {
            pPrice += '<div class="price" data-price="">';
        }
        if (product.compare_at_price > product.price) {
            pPrice += '<div class="price__regular"><span class="price-item price-item--regular" data-regular-price><span class=money>'+ Shopify.formatMoney(product.compare_at_price) +'</span></span></div>';
        } else {
            pPrice += '<div class="price__regular"><span class="price-item price-item--regular" data-regular-price><span class=money>'+ Shopify.formatMoney(product.price) +'</span></span></div>';
        }
        pPrice += '<div class="price__sale"><span class="price-item price-item--sale" data-sale-price><span class=money>'+ Shopify.formatMoney(product.price) +'</span></span></div>';
        pPrice += '</div></td>';
        var pButton = '';
        if (product.available) {
            var variants = product.variants;
            if (variants.length > 1) {
                pButton = '<a href="'+ product.url +'" class="btn btn--secondary btn-select-option js-open-quickview">'+ selectOptionText +'</a>';
            } else {
                pButton = '<a href="'+ product.url +'" class="btn btn--secondary btn-add-to-cart" data-vid="'+ variants[0].id +'">'+ addToCartText +'</a>';
            }
        } else {
            pButton = '<a href="'+ product.url +'" class="btn btn--secondary btn-soldout">'+ soldOutText +'</a>';
        }
        var qVButton='';
        qVButton = ' <a href="'+ product.url +'" class="btn btn-quick-view js-open-quickview"><span class="theme-iconsearch-1"></span></a>';

        var itemHtml = '<li class="product-item" data-product-handle="'+ product.handle +'"><div class="product">'+ pImage + '<div class="product-item-details">'+ pTitle + pPrice + '<div class="product-buttons">'+ pButton + qVButton + '</div></div></div></li>';

        $('.gp-wishlist-page-wrapper .wishlist-items').append(itemHtml);
    }

  function removeProductFromWishlist(handle, wishlistProducts) {
    var btnWishlist = $('.btn-wishlist[data-product-handle="'+ handle +'"]');
    if (btnWishlist) {
      btnWishlist.removeClass('added').attr('title', btnWishlist.data('wishlist-add'));
    }
    if (wishlistProducts.length) {
      $('.wishlist-slideout .product-item[data-product-handle="'+ handle +'"]').remove();
      $('.gp-wishlist-page-wrapper .product-item[data-product-handle="'+ handle +'"]').remove();
      for (var i = 0; i < wishlistProducts.length; i++) {
        if (handle == wishlistProducts[i]) {
          wishlistProducts.splice(i, 1);
          break;
        }
      }
      if(!wishlistProducts.length) {
        showHideWishlist(false);
      }
      localStorage.setItem("wishlistList", JSON.stringify(wishlistProducts));
      Cookies2.set("wishlist-expire", 1, 1);
    }
  }

  var wishlistProducts = [];
  if (typeof(Storage) !== "undefined") {
    if (localStorage.getItem("wishlistList")) {
      if (Cookies2.get("wishlist-expire") === undefined) {
        localStorage.removeItem("wishlistList");
      } else {
        wishlistProducts = $.parseJSON(localStorage.getItem("wishlistList"));
      }
      if (wishlistProducts.length) {
        for (var i = 0; i < wishlistProducts.length; i++) {
          var btnWishlist = $('.btn-wishlist[data-product-handle="'+ wishlistProducts[i] +'"]');
          if (btnWishlist) {
            btnWishlist.addClass('added').attr('title', btnWishlist.data('wishlist-added'));
          }
        }
        showHideWishlist(true);
      } else {
        showHideWishlist(false);
      }
    } else {
      showHideWishlist(false);
    }
    $(document).on('click', '.btn-wishlist-close', function(e) {
      $('.wishlist-slideout').removeClass('active');
      $('.wishlist-slideout-container').removeClass('active');
    });
    $(document).on('click', '.btn-remove-wishlist', function(e) {
      e.preventDefault();
      var handle = $(this).data('product-handle');
      removeProductFromWishlist(handle, wishlistProducts);
      $('.toggle-wishlist-slide .counter-number').html(wishlistProducts.length);
    });
    $(document).on('click', '.my-account-link .link.wishlist a', function(e) {
      e.preventDefault();
      $('.wishlist-slideout').addClass('active');
      $('.wishlist-slideout-container').addClass('active');
      if (wishlistProducts.length) {
        $('.btn-wishlist').addClass('loading');
        $('.wishlist-slideout').addClass('loading');
        $('.wishlist-slideout .wishlist-items .product-item').remove();
        var cnt = 0;
        for (var i = 0; i < wishlistProducts.length; i++) {
          $.getJSON('/products/'+ wishlistProducts[i] +'.js', function(product) {
            cnt++;
            addProductHtmlToWishlist(product);
            if (cnt = wishlistProducts.length) {
              $('.btn-wishlist').removeClass('loading');
              $('.wishlist-slideout').removeClass('loading');
            }
            //reinit currency
            Currency.convertAll(theme.currency, Currency.currentCurrency);
          });
        }
        showHideWishlist(true);
      } else {
        showHideWishlist(false);
      }
    });
    $(document).on('click', '.btn-wishlist', function(e) {
      e.preventDefault();
      var handle = $(this).data('product-handle');
      if ($(this).hasClass('added')) {
        // remove wishlist
        removeProductFromWishlist(handle, wishlistProducts);
        $('.toggle-wishlist-slide .counter-number').html(wishlistProducts.length);
      } else {
        // add wishlist
        var inArray = false;
        for (var i = 0; i < wishlistProducts.length; i++) {
          if (handle == wishlistProducts[i]) {
            inArray = true;
            break;
          }
        }
        if(!inArray) {
          wishlistProducts.unshift(handle);
        }
        if (wishlistProducts.length) {
          $('.btn-wishlist').addClass('loading');
          $('.wishlist-slideout').addClass('loading');
          $('.wishlist-slideout .wishlist-items .product-item').remove();
          var cnt = 0;
          for (var i = 0; i < wishlistProducts.length; i++) {
            $.getJSON('/products/'+ wishlistProducts[i] +'.js', function(product) {
              cnt++;
              addProductHtmlToWishlist(product);
              if (cnt = wishlistProducts.length) {
                $('.btn-wishlist').removeClass('loading');
                $('.wishlist-slideout').removeClass('loading');
              }
              //reinit currency
              Currency.convertAll(theme.currency, Currency.currentCurrency);
            });
          }
          showHideWishlist(true);
        } else {
          showHideWishlist(false);
        }

        var btnWishlist = $('.btn-wishlist[data-product-handle="'+ handle +'"]');
        if (btnWishlist) {
          btnWishlist.addClass('added').attr('title', btnWishlist.data('wishlist-added'));
        }
        localStorage.setItem("wishlistList", JSON.stringify(wishlistProducts));
        Cookies2.set("wishlist-expire", 1, 1);
        $('.toggle-wishlist-slide .counter-number').html(wishlistProducts.length);
        // show wishlist slideout
        $('.wishlist-slideout').addClass('active');
        $('.wishlist-slideout-container').addClass('active');
      }
    });

    function showWishlistHeader() {
      $('.wishlist-slideout').addClass('active');
      $('.wishlist-slideout-container').addClass('active');
      if (wishlistProducts.length) {
        $('.btn-wishlist').addClass('loading');
        $('.wishlist-slideout').addClass('loading');
        $('.wishlist-slideout .wishlist-items .product-item').remove();
        var cnt = 0;
        for (var i = 0; i < wishlistProducts.length; i++) {
          $.getJSON('/products/'+ wishlistProducts[i] +'.js', function(product) {
            cnt++;
            addProductHtmlToWishlist(product);
            if (cnt = wishlistProducts.length) {
              $('.btn-wishlist').removeClass('loading');
              $('.wishlist-slideout').removeClass('loading');
            }
            //reinit currency
            Currency.convertAll(theme.currency, Currency.currentCurrency);
          });
        }
        showHideWishlist(true);
      } else {
        showHideWishlist(false);
      }
    }

    $(document).on('click', '.toggle-wishlist-slide:not(.link-page)', function(e) {
      e.preventDefault();
      showWishlistHeader()
    });

  } else {
    Console.log('No Web Storage support..');
  }
  if(wishlistProducts.length >=1){
      $('.toggle-wishlist-slide .counter-number').html(wishlistProducts.length);
      for (var i = 0; i < wishlistProducts.length; i++) {
          $.getJSON('/products/'+ wishlistProducts[i] +'.js', function(product) {
              addProductHtmlToWishlistPage(product);
          });
      }
  }

  /* CHANGE IMAGE ON PRODUCT ITEM WHEN CLICK ON SWATCH OPTION */
  $(document).on('click', '.product-card-item .product-item-details .color-swatch .swatch', function(e) {
    e.preventDefault();
    $(this).siblings().removeClass('active');
    $(this).addClass('active');
    // change image
    var vImageUrl = $(this).data('variant-image');
    if (vImageUrl && vImageUrl != '') {
      var pImage = $(this).closest('.product-card-item').find('.image .hover-change-img img');
      if (pImage.length) {
        pImage.first().attr('data-src', vImageUrl);
      }
    }
  });

  /* TOGGLE FILTER DROPDOWN ON COLLECTION PAGE */
if($('.gp-collection').hasClass('gp-collection-1-column')){
  $('.gp-collection-filter-wrapper').addClass('not-active');
   $(document).on('click', '.gp-collection-1-column .js-toggle-filter', function(e) {
    if ($('.gp-collection-filter-wrapper').hasClass('not-active')) {
      $('.gp-collection-filter-wrapper').removeClass('not-active');
      $('.gp-collection-1-column .gp-collection-filter-wrapper').slideDown(600,'linear');
  } else {
      $('.gp-collection-filter-wrapper').addClass('not-active');
      $('.gp-collection-1-column .gp-collection-filter-wrapper').slideUp(600,'linear');
  }
  });
 }else{
  $(document).on('click', '.js-toggle-filter', function(e) {
    e.preventDefault();
    $(this).toggleClass('active');
    $('.gp-collection-filter-wrapper').toggleClass('active');
  });

}

  $(document).on('click', '.mobile-close-filter-slideout', function() {
    $('.js-toggle-filter').removeClass('active');
    $('.gp-collection-filter-wrapper').removeClass('active');
  });
  $(document).on('click', function(e) {
    var container = $('.gp-collection-filter-wrapper');
    var container2 = $('.filter-title.js-toggle-filter');
    if (!container.is(e.target) && container.has(e.target).length === 0 && !container2.is(e.target) && container2.has(e.target).length === 0) {
      $('.filter-title.js-toggle-filter').removeClass('active');
      $('.gp-collection-filter-wrapper').removeClass('active');
    }
  });

  /* TOGGLE LINKLIST ON FILTER DROPDOWN */
  $(document).on('click', '.js-toggle-linklist', function() {
    $(this).toggleClass('active');
    $(this).next().slideToggle(300);
  });



  /* COLLECTION MODE */
  var viewMode = sessionStorage.getItem('current-view-mode');
  if (viewMode) {
    if ($('.gp-products .grid-mode').length && $('.gp-products .list-mode').length) {
      if (viewMode == 'list') {
        $('.gp-products .grid-mode').hide();
        $('.gp-products .list-mode').show();
        $('.gp-products').removeClass('viewing-grid');
        $('.gp-products').addClass('viewing-list');
        $('.gp-view-mode .gp-view-mode-item').removeClass('active');
        $('.gp-view-mode .gp-view-mode-item.gp-view-mode-list').addClass('active');
      } else {
        $('.gp-products .list-mode').hide();
        $('.gp-products .grid-mode').show();
        $('.gp-products').removeClass('viewing-list');
        $('.gp-products').addClass('viewing-grid');
        $('.gp-view-mode .gp-view-mode-item').removeClass('active');
        $('.gp-view-mode .gp-view-mode-item.gp-view-mode-grid').addClass('active');
      }
    }
  }
  $(document).on('click', '.gp-view-mode .gp-view-mode-item', function(e) {
    e.preventDefault();
    if (!$(this).hasClass('active')) {
      $('.gp-view-mode .gp-view-mode-item').removeClass('active');
      $(this).addClass('active');
      if ($('.gp-products .grid-mode').length && $('.gp-products .list-mode').length) {
        if ($(this).hasClass('gp-view-mode-list')) {
          $('.gp-products .grid-mode').slideUp();
          $('.gp-products .list-mode').slideDown();
          $('.gp-products').removeClass('viewing-grid');
          $('.gp-products').addClass('viewing-list');
          sessionStorage.setItem('current-view-mode', 'list');
        } else {
          $('.gp-products .list-mode').slideUp();
          $('.gp-products .grid-mode').slideDown();
          $('.gp-products').removeClass('viewing-list');
          $('.gp-products').addClass('viewing-grid');
          sessionStorage.setItem('current-view-mode', 'grid');
        }
      }
    }
  });

 
  
  /* PRODUCT SWATCH */
  $(document).on('click', '.gp-product-detail .gp-swatch .option-item', function(e) {
    e.preventDefault();
    var option = $(this).data('option');
    var value = $(this).data('value');
    if (value) {
      $(this).closest('form').find('select[data-option="'+ option +'"]').val(value).change();
      $(this).siblings().removeClass('selected');
      $(this).addClass('selected');
      $(this).parents('.product-form__item').find('.selected-value').text(value);
    }
  });

  $(document).on('change', '.gp-product-detail .selector-wrapper .single-option-selector', function(e) {
    e.preventDefault();
    var value = $(this).val();
    $(this).parents('.product-form__item').find('.selected-value').text(value);
  });

  $(document).on('click', '.gp-product-detail-quickview select.product-form__input', function(e) {

      var text = "";
      $(this).closest('form').find('select.product-form__input').each(function(i, el) {
        if(i == 0) {
          text += $(el).val() 
        } else {
          text += " / " + $(el).val();
        }
      });

      $(this).siblings().removeClass('selected');
      $(this).closest('form').find("select.product-form__variants option:selected").prop('selected', false);

      var d = $(this).closest('form').find("select.product-form__variants option").filter(function() {
        return $(this).text().trim() == text;
      })
      if (d.length == 1) {
        d.prop("selected", true)
        $('#AddToCart-quickview').attr("disabled", false)
        var selected = $(this).closest('form').find("select.product-form__variants option:selected")
        var price = selected.attr("data-price")
        var variant_price = Shopify.formatMoney( Currency.convert(price ,  theme.currency, Currency.currentCurrency), Currency.moneyFormats[Currency.currentCurrency].money_format)
        $('#gp-popup-quickview .product-info-price .money').html(variant_price)

        if (selected.attr("disabled")) {
          $('#AddToCart-quickview').html($('#AddToCart-quickview').attr("data-text-soldout"))
        } else {
          $('#AddToCart-quickview').html($('#AddToCart-quickview').attr("data-text-add-to-cart"))
        }
      } else {
        $('#gp-popup-quickview .product-info-price .money').html($('#AddToCart-quickview').attr("data-text-unavailable"))
        $('#AddToCart-quickview').attr("disabled", true)
        $('#AddToCart-quickview').html($('#AddToCart-quickview').attr("data-text-unavailable"))
      }
  });

  $(document).on('click', '.gp-product-detail-quickview .gp-swatch .option-item, .sticky-product .gp-swatch .option-item', function(e) {
    e.preventDefault();
    var option = $(this).data('option');
    var value = $(this).data('value');
    var id = $(this).data('variant-id');
    $(this).addClass("selected");
    if (value) {
      $(this).closest('form').find('select[data-option="'+ option +'"]').val(value).change();

      var text = "";
      $(this).closest('form').find('select.product-form__input').each(function(i, el) {
        if(i == 0) {
          text += $(el).val() 
        } else {
          text += " / " + $(el).val();
        }
      });

      $(this).siblings().removeClass('selected');

      $(this).closest('form').find("select.product-form__variants option:selected").prop('selected', false);


      var d = $(this).closest('form').find("select.product-form__variants option").filter(function() {
        return $(this).text().trim() == text;
      })
      if (d.length == 1) {
        d.prop("selected", true)
        $('#AddToCart-quickview').attr("disabled", false)
        var selected = $(this).closest('form').find("select.product-form__variants option:selected")
        var price = selected.attr("data-price")
        var variant_price = Shopify.formatMoney( Currency.convert(price ,  theme.currency, Currency.currentCurrency), Currency.moneyFormats[Currency.currentCurrency].money_format)
        $('#gp-popup-quickview .product-info-price .money').html(variant_price)

        if (selected.attr("disabled")) {
          $('#AddToCart-quickview').html($('#AddToCart-quickview').attr("data-text-soldout"))
        } else {
          $('#AddToCart-quickview').html($('#AddToCart-quickview').attr("data-text-add-to-cart"))
        }
      } else {
        $('#gp-popup-quickview .product-info-price .money').html($('#AddToCart-quickview').attr("data-text-unavailable"))
        $('#AddToCart-quickview').attr("disabled", true)
        $('#AddToCart-quickview').html($('#AddToCart-quickview').attr("data-text-unavailable"))
      }
    }
  });

  /* PRODUCT TAB */
  $(document).on('click', '.product-detail-infomation.type-1 .product-data-items-menu .tab-title a', function(e) {
    e.preventDefault();
    var parent = $(this).parent();
    if (!parent.hasClass('active')) {
      var id = $(this).attr('href');
      parent.siblings().removeClass('active');
      parent.addClass('active');
      $('.gp-product-col-information .product-data-items-content .tab-content').removeClass('active');
      $(id).addClass('active');
    }
  });
  $(document).on('click', '.product-detail-infomation.type-2 .product-data-items-content .tab-title a', function(e) {
    e.preventDefault();
    var parent = $(this).parent();
    var id = $(this).attr('href');
    parent.toggleClass('active');
    $(id).toggleClass('active');
  });

  /* PRODUCT QTY BUTTON */
  $(document).on('click', '.edit-qty', function(e) {
    e.preventDefault();
    if ($(this).hasClass('minus')) {
      var qty = parseInt($(this).next().val());
      if (qty > 1) {
        qty = qty - 1;
        $(this).next().val(qty);
      } else {
        $(this).next().val(1);
      }
    } else {
      var qty = parseInt($(this).prev().val());
      if (qty) {
        $(this).prev().val(qty + 1);
      } else {
        $(this).prev().val(1);
      }
    }
  });
  $(document).on('change', '.qty-input', function(e) {
    if ($(this).val() <= 0 || $(this).val() == '') {
      $(this).val(1);
    }
  });

  /* NAV TAB */
  $(document).on('click', '.nav-tabs-faqs li a', function(e) {
    e.preventDefault();
    $('.tab-pane').removeClass('active');
    var href = $(this).data('id');
    var class_faqs = $('.tab-pane.'+ href);
    $(this).parent().siblings().removeClass('active');
    class_faqs.siblings().removeClass('active');
    $(this).parent().addClass('active');
    $(this).next().addClass('active');
    class_faqs.addClass('active');
    class_faqs.find('.slick-slider').slick('setPosition');
  });

  $(document).on('click', '.nav-tabs li a', function(e) {
    e.preventDefault();
    var href = $(this).attr('href');
    $(this).parent().siblings().removeClass('active');
    $('.tab-pane'+ href).siblings().removeClass('active');
    $(this).parent().addClass('active');
    $('.tab-pane'+ href).addClass('active');
    $('.tab-pane'+ href).find('.slick-slider').slick('setPosition');
  });

  $(document).on('change', '.mobile-tab select', function() {
    var val = $(this).val();
    $('.tab-pane'+ val).siblings().removeClass('active');
    $('.tab-pane'+ val).addClass('active');
    $('.tab-pane'+ val).find('.slick-slider').slick('setPosition');
  });

  
    /* SCROLL TO TOP */
    if ($(window).scrollTop() > 20) {
      $('.scroll-to-top').removeClass('hidden');
    } else {
      $('.scroll-to-top').addClass('hidden');
    }
    $(window).scroll(function(){
      if ($(this).scrollTop() > 20) {
        $('.scroll-to-top').removeClass('hidden');
      } else {
        $('.scroll-to-top').addClass('hidden');
      }
    });

    $(document).on('click', '.scroll-to-top', function(){
      $('html, body').animate({scrollTop: '0px'}, 800);
      return false;
    });
  

  /* Load more products on pages */
  $('.paginate-product .load-more-products').on('click', function(){
    var $this = $(this);
    var next_url = $this.data('next-url');
    var id_collection_product = $this.parent().parent().attr('id');
    var products_on_page = $('#'+id_collection_product).find('.products-on-page');
    $.ajax({
      url: next_url,
      type:'GET',
      dataType:'html',
      beforeSend: function () {
        $this.after('<div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>');
        $this.hide();
      },
      success: function (data) {
        var news_product = $(data).find('#'+id_collection_product).find('.products-on-page');
        var new_url = $(data).find('#'+id_collection_product).find('.load-more-products').data('next-url');
        $this.parent().find('.lds-ellipsis').remove();
        if(new_url){
          $this.show();
        }
        products_on_page.append(news_product.html());
        $this.data('next-url',new_url);
      }
    });
  });

  //TOGGLE

  //Click vertical-link-list in footer
  $(document).on('click','.site-footer .vertical-link-list-wrapper.show-toggle-mb .title-content', function() {
    $(this).next().toggleClass('active');
    $(this).toggleClass('active');
  });

  //Click product column widget
  $(document).on('click','.gp-product-column-widget .column-title i', function() {
    $(this).parent().next().toggleClass('active');
    $(this).parent().toggleClass('active');
  });

  //Click custom content in section video
  $(document).on('click', '.gp-video-section .custom-content-block .custom-sub-title', function() {
      $(this).toggleClass('active');
      $(this).next().slideToggle();
  });
  //Accordion
  var questionDiv = $('.faq-title');
  var answerDiv = $('.faq-content');

  $(questionDiv).click(function() {
    if ($(this).next().hasClass('openFAQ')) {
      $(this).removeClass('active');
      $(this).next().removeClass('openFAQ').addClass('closedFAQ').slideUp(300);
    } else if ($(answerDiv).hasClass('openFAQ')) {
      $(answerDiv).removeClass('openFAQ').addClass('closedFAQ').slideUp(300);
      $(questionDiv).removeClass('active');
      $(this).next().removeClass('closedFAQ').addClass('openFAQ').slideDown(300);
      $(this).addClass('active');
    } else {
      $(this).next().removeClass('closedFAQ').addClass('openFAQ').slideDown(300);
      $(this).addClass('active');
    }
  });

  // LOOKBOOK PIN IN MOBILE
  if ($(document).width() < 1025) {
    $(document).on('click', '.pin-wrapper', function() {
      var pin_id = $(this).data('block-id');
      var id = $(this).children('.pin-content').attr('id');
      if (id == pin_id) {
        $.magnificPopup.open({
          items: [
            {
              src: '#' + id
            }
          ],
          type: 'inline',
          mainClass: 'modal_pin_lookbook mfp-fade',
          removalDelay: 300
        });
      }
    });
  }

  $(document).on('click', function(e) {
    var container = $('.prompt-background');
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      $(".prompt-background").hide();
    }
  });
  function debounce(func, wait, immediate) {
    var timeout;

    return function executedFunction() {
      var context = this;
      var args = arguments;

      var later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };

      var callNow = immediate && !timeout;

      clearTimeout(timeout);

      timeout = setTimeout(later, wait);

      if (callNow) func.apply(context, args);
    };
  };
  function predictSearch(val,pos) {
    if(val != "") {
      jQuery.getJSON("/search/suggest.json", {
        "q": val,
        "resources": {
          "type": "collection,product,page,article",
          "options": {
            "unavailable_products": "last"
          }
        }
      }).done(function(response) {
      pos.show();
        var result = response.resources.results;
        var product = $(pos).find(".product-recommendation");
        var article = $(pos).find(".article-recommendation");
        var collection = $(pos).find(".collection-recommendation");
        var page = $(pos).find(".page-recommendation");
           
        if(collection) {
          collection.empty();
          if(result.collections.length > 0) {
            $("div[data-suggest-type=collection]").show()
            var limit = collection.data("limit");
            if (result.collections.length > limit) {
              $('.search-collection-load-more').attr("href", "/search?type=collections&options[prefix]=last&q="+val);
              $('.search-collection-load-more').html("<span>View all</span>");
              $('.search-collection-load-more').addClass("show");
            } else {
              $('.search-collection-load-more').removeClass("show");
            }

            var c =``;
            result.collections.slice(0, limit).map(function(collection) {
            c += `<div class="collection-recommendation-result">
                  <a class="collection-title" href="${collection.url}">${collection.title}</a>
                  </div>`;
            })
                 
            collection.append(c);
          } else {
            $("div[data-suggest-type=collection]").hide();
          }
        }
           
        if(product) {
          product.empty()
          if(result.products.length > 0) {
            $("div[data-suggest-type=product]").show()
            var limit = product.data("limit");
            if (result.products.length > limit) {
              $('.search-product-load-more').attr("href", "/search?type=product&options[prefix]=last&q="+val);
              $('.search-product-load-more').html("View all");
              $('.search-product-load-more').addClass("show");
            } else {
              $('.search-product-load-more').removeClass("show");
            }
            var d =``;
            result.products.slice(0, limit).map(function(product) {
              d += `<div class="product-item">`;
              if (product.image != null) {
                d += `<div class="image-wrapper"><a href="${product.url}"><img alt="${product.title}" src="${product.image}"></a></div>`;
              }
              d += `<div class="product-recommendation-result">
                      <a class="product-title" href="${product.url}">${product.title}</a>
                      <div class="bottom-details">
                        <div class="price">`;
                        if(Currency) {
                          d += Shopify.formatMoney(Currency.convert(product.price * 100,  theme.currency, Currency.currentCurrency), Currency.moneyFormats[Currency.currentCurrency].money_format)
                        } else {   
                          d += `${Shopify.formatMoney(product.price, theme.moneyFormat)}`
                        }
              d += `</div></div></div></div>`;
            })

            product.append(d);
          } else {
            $("div[data-suggest-type=product]").hide();
          } 
        }

        if(article) {
          article.empty();
          if(result.articles.length > 0) {
            $("div[data-suggest-type=article]").show();
            var a = ``;
            var limit = article.data("limit");
            if (result.articles.length > limit) {
              $('.search-article-load-more').attr("href", "/search?type=article&options[prefix]=last&q="+val);
              $('.search-article-load-more').html("View all");
              $('.search-article-load-more').addClass("show");
            } else {
              $('.search-article-load-more').removeClass("show");
            }
            result.articles.slice(0, limit).map(function(article){
            a += `<div class="article-wrapper">`
            if (article.image != null) {
              a +=`<div class="image-wrapper"><a href="${article.url}"><img src="${article.image}" alt="${article.title}"/></a></div>` 
            }
            a += `<a href="${article.url}" class="article-title">${article.title}</a></div>`;
            })
            article.append(a);
          } else {
            $("div[data-suggest-type=article]").hide();
          }
        }
           
        if(page) {
          page.empty();
          if(result.pages.length > 0) {
            $("div[data-suggest-type=page]").show();
            var f = ``;
            var limit = page.data("limit");
            if (result.pages.length > limit) {
              $('.search-page-load-more').attr("href", "/search?type=page&q="+val);
              $('.search-page-load-more').html("View all");
              $('.search-page-load-more').addClass("show");
            } else {
              $('.search-page-load-more').removeClass("show");
            }
            result.pages.slice(0, limit).map(function(page){
              f += `<div class="page-wrapper"><a href="${page.url}">${page.title}</a></div>`;
            })
            page.append(f);
          } else {
            $("div[data-suggest-type=page]").hide();
          }
        }
             
        if(result.pages.length == 0 && result.products.length == 0 && result.collections.length == 0 && result.articles.length == 0){
          $(".no-result").addClass("show");
        }
      });
    }
  }
  
  $("input.search__input[type=search]").on( "input", function(e) {
    $('input.search__input[type=search]').closest('form').find('.ajax-loader').show();
    var val = $(this).val();
    var pos = $(this).parent('form').next('.prompt-background');
    $.when(predictSearch(val,pos)).then(function() {
      $('input.search__input[type=search]').closest('form').find('.ajax-loader').hide();
    });
   });
  var ajaxload = `<div class="ajax-loader"></div>`
  $('input.search__input[type=search]').closest('form').append(ajaxload);
  $('input.search__input[type=search]').closest('form').on('submit', function(e){
  // validation code here
    e.preventDefault();
    var val = $(this).find("input.search__input[type=search]").val();
    var t = $(".recommendation-content:visible .suggest-title a").attr("href");

    if (t != undefined) {
      window.location.href = t;
    } else {
      window.location.href = `/search?type=product&options[prefix]=last&q=${val}`;
    }
  });

  Shopify.formatMoney = function(cents, format) {
    if (typeof cents == 'string') { cents = cents.replace('.',''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) { return 0; }

      number = (number/100.0).toFixed(precision);

      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_with_apostrophe_separator":
          value = formatWithDelimiters(cents, 2, "'", ".");
          break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };

  /* External Link Popup */
  
  
    $('.delivery-open-popup').magnificPopup({
      type:'inline',
      midClick: true
    });
  

  $(document).on('click', '.gp-lookbook-slider .lookbook-item .pin-wrapper', function() {
    var id = $(this).data('block-id');
    $('.gp-lookbook-slider .lookbook-item .pin-product-image').removeClass('active');
    $('.gp-lookbook-slider .lookbook-item .pin-wrapper').removeClass('active');
    if ($('.gp-lookbook-slider .lookbook-item .pin-product-image').length) {
      $('.gp-lookbook-slider .lookbook-item .pin-product-image').each(function() {
        var block_product_id = $(this).data('block-id');
        if (block_product_id == id) {
          $(this).addClass('active');
        }
      })
    }
  });
  // click outsite close lookbook
  $(document).on('click', function(e) {
      var container_lookbook = $('.gp-lookbook-slider .lookbook-item .pin-wrapper');
      var container_lookbook2 = $('.gp-lookbook-slider .lookbook-item .pin-product-image');
      if (!container_lookbook.is(e.target) && container_lookbook.has(e.target).length === 0 && !container_lookbook2.is(e.target) && container_lookbook2.has(e.target).length === 0) {
        $('.gp-lookbook-slider .lookbook-item .pin-product-image').removeClass('active');
        $('.gp-lookbook-slider .lookbook-item .pin-wrapper').removeClass('active');
      }
  });

  // Slider mobile of Lookbook Single Product
  if ($(window).width() < 1025) {
    $('.gp-single-lookbook .pin-slider-mobile').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        fade: false,
        pauseOnHover: true,
        autoplay: true,
        autoplaySpeed: 5000
    });
  }
  $(window).resize(function () {
    if ($(window).width() < 1025) {
      $('.gp-single-lookbook .pin-slider-mobile').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        fade: false,
        pauseOnHover: true,
        autoplay: true,
        autoplaySpeed: 5000
      });
    }
  });
  if ($(window).width() > 1024) {
    $(document).on('click', '.gp-single-lookbook .pin-wrapper', function() {
      $(this).toggleClass('nonactive');
    });
  }
});